export default {"src":"/_next/static/image/public/images/ic_knob.01f8385bb8f419386eef176c37b6f8c9.svg","height":31,"width":31};